import { PersistedMetamodel } from '@ardoq/api-types';
import {
  addMetamodel,
  removeMetamodel,
  setMetamodels,
  updateMetamodel,
} from './metamodelActions';
import { reducer } from '@ardoq/rxbeach';
import { removeEntityById } from '@ardoq/common-helpers';

const order = (a: PersistedMetamodel, b: PersistedMetamodel) => {
  if (a.wholeOrg) return -1;
  if (b.wholeOrg) return 1;
  if (a._id === b._id) return 0;
  if (a._id < b._id) return -1;
  return 1;
};

const handleSetMetamodels = (
  _currentState: PersistedMetamodel[],
  metamodels: PersistedMetamodel[]
) => [...metamodels].sort(order);

const handleAddMetamodel = (
  currentState: PersistedMetamodel[],
  metamodel: PersistedMetamodel
) => [...currentState, metamodel].sort(order);

const handleUpdateMetamodel = (
  currentState: PersistedMetamodel[],
  metamodel: PersistedMetamodel
) =>
  [...currentState.filter(({ _id }) => _id !== metamodel._id), metamodel].sort(
    order
  );

const reducers = [
  reducer(setMetamodels, handleSetMetamodels),
  reducer(addMetamodel, handleAddMetamodel),
  reducer(updateMetamodel, handleUpdateMetamodel),
  reducer(removeMetamodel, removeEntityById<PersistedMetamodel>),
];

export { reducers };
